module.exports = __webpack_public_path__ + "static/media/old mutual.1b749edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/old mutual.jpg
// module id = 2815
// module chunks = 0